<script>
import { mapActions } from "vuex";
import errorMixin from "@/mixins/errorMixin";
import Modal from "@/components/_Shared/Modal";
import InputGroup from "@/components/_Shared/InputGroup";
import Phone from "@/components/_Shared/Forms/Phone";

export default {
  mixins: [errorMixin],
  components: {
    Modal,
    InputGroup,
    Phone
  },
  data() {
    return {
      preloader: false,
      legal: {
        cnpj: "",
        company_name: "",
        business_name: ""
      },
      account: {
        email: "",
        first_name: "",
        last_name: "",
        password: "",
        password_confirmation: ""
      },
      profile: {
        profile_picture: "",
        city_name: "",
        state_name: "",
        birthdate: "//"
      },
      phones: [{ country_code: "55", area_code: "", number: "" }],
      legalRepresentative: {
        firstName: "",
        lastName: "",
        cpf: "",
        birthdate: "//",
        address: {
          street: "",
          street_number: "",
          complement: "",
          district: "",
          city: "",
          state: "",
          country: "BRA",
          zip_code: ""
        },
        phone: { countryCode: "55", areaCode: "", number: "" }
      }
    };
  },
  methods: {
    ...mapActions("legals", ["create"]),

    async submit() {
      this.preloader = true;

      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          let payload = {
            legal: this.legal,
            account: this.account,
            profile: this.profile,
            phones: this.phones,
            address: this.legalRepresentative.address,
            legalRepresentative: this.legalRepresentative
          };

          await this.create(payload);
          this.$emit("close");
          this.$emit("refresh");
        } else {
          this.preloader = false;
        }
      } catch (e) {
        this.preloader = false;
        this.$emit("errorMessage", e[0].detail);
        this.inputErrors(e);
      }
      this.preloader = false;
    }
  }
};
</script>

<template>
  <modal
    title="NOVO CLIENTE B2B"
    subtitle="Informe os dados do novo cliente (todos são obrigatórios)"
    size="lg"
    @close="$emit('close')"
  >
    <template slot="body">
      <v-layout row class="title-form">DADOS DA EMPRESA</v-layout>

      <!-- CNPJ -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="cnpj"
            v-model="legal.cnpj"
            label="cnpj"
            :error="errors.has('cnpj')"
            :error-messages="errors.first('cnpj')"
            v-validate="'required|numeric|length:14'"
            mask="##.###.###/####-##"
          />
        </v-flex>
        <v-flex px-1 md6 xs12>
          <phone label="telefone" v-model="phones[0]" />
        </v-flex>
      </v-layout>
      <!-- COMPANY AND BUSINESS NAME -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="nome fantasia"
            v-model="legal.company_name"
            label="nome fantasia"
            :error-messages="errors.first('nome fantasia')"
            :error="errors.has('nome fantasia')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="razão social"
            v-model="legal.business_name"
            label="razão social"
            :error="errors.has('razão social')"
            :error-messages="errors.first('razão social')"
            v-validate="'required'"
          />
        </v-flex>
      </v-layout>
      <!-- CITY AND STATE NAMES -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="cidade da empresa"
            v-model="profile.city_name"
            label="cidade da empresa"
            :error-messages="errors.first('cidade da empresa')"
            :error="errors.has('cidade da empresa')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="UF da empresa"
            v-model="profile.state_name"
            label="UF da empresa"
            :error="errors.has('UF da empresa')"
            :error-messages="errors.first('UF da empresa')"
            v-validate="'required'"
          />
        </v-flex>
      </v-layout>

      <v-layout row class="title-form">PESSOAL</v-layout>
      <!-- FIRST AND LAST NAME -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="nome"
            v-model="account.first_name"
            label="nome"
            :error-messages="errors.first('nome')"
            :error="errors.has('nome')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="sobrenome"
            v-model="account.last_name"
            label="sobrenome"
            :error="errors.has('sobrenome')"
            :error-messages="errors.first('sobrenome')"
            v-validate="'required'"
          />
        </v-flex>
      </v-layout>
      <!-- EMAIL -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="email"
            v-model="account.email"
            label="email"
            :error="errors.has('email')"
            :error-messages="errors.first('email')"
            v-validate="'required|email'"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="data de nascimento"
            v-model="profile.birthdate"
            label="data de nascimento"
            :error-messages="errors.first('data de nascimento')"
            :error="errors.has('data de nascimento')"
            v-validate="'required'"
            return-masked-value
            mask="##/##/####"
          />
        </v-flex>
      </v-layout>
      <!-- PASSWORD AND CONFIRM PASSWORD -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="senha"
            v-model="account.password"
            label="senha"
            :error-messages="errors.first('senha')"
            :error="errors.has('senha')"
            v-validate="'required|min:8'"
            ref="senha"
            type="password"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="confirmação da senha"
            v-model="account.password_confirmation"
            label="confirme a senha"
            :error="errors.has('confirmação da senha')"
            :error-messages="errors.first('confirmação da senha')"
            v-validate="'required|min:8|confirmed:senha'"
            type="password"
          />
        </v-flex>
      </v-layout>

      <v-layout row class="title-form">REPRESENTANTE</v-layout>
      <!-- FIRST AND LAST NAME -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="nome do representante"
            v-model="legalRepresentative.firstName"
            label="nome do representante"
            :error-messages="errors.first('nome do representante')"
            :error="errors.has('nome do representante')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="sobrenome do representante"
            v-model="legalRepresentative.lastName"
            label="sobrenome do representante"
            :error="errors.has('sobrenome do representante')"
            :error-messages="errors.first('sobrenome do representante')"
            v-validate="'required'"
          />
        </v-flex>
      </v-layout>
      <!-- BIRTHDATE AND CPF -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md6 xs12>
          <v-text-field
            name="data de nascimento"
            v-model="legalRepresentative.birthdate"
            label="data de nascimento"
            :error-messages="errors.first('data de nascimento')"
            :error="errors.has('data de nascimento')"
            v-validate="'required'"
            return-masked-value
            mask="##/##/####"
          />
        </v-flex>

        <v-flex px-1 md6 xs12>
          <v-text-field
            name="cpf"
            v-model="legalRepresentative.cpf"
            label="cpf"
            :error="errors.has('cpf')"
            :error-messages="errors.first('cpf')"
            v-validate="'required|numeric|length:11'"
            mask="###.###.###-##"
          />
        </v-flex>
      </v-layout>
      <!-- REPRESENTATIVE PHONE NUMBER -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 xs12>
          <phone
            :label="'celular representante'"
            v-model="legalRepresentative.phone"
          />
        </v-flex>
      </v-layout>
      <!-- STREET, COMPLEMENT, ZIP CODE AND NUMBER-->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md5 xs12>
          <v-text-field
            name="rua"
            v-model="legalRepresentative.address.street"
            label="rua"
            :error-messages="errors.first('rua')"
            :error="errors.has('rua')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md2 xs12>
          <v-text-field
            name="número"
            v-model="legalRepresentative.address.street_number"
            label="número"
            :error="errors.has('número')"
            :error-messages="errors.first('número')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md3 xs12>
          <v-text-field
            name="complemento"
            v-model="legalRepresentative.address.complement"
            label="complemento"
            :error-messages="errors.first('complemento')"
            :error="errors.has('complemento')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md2 xs12>
          <v-text-field
            name="cep"
            v-model="legalRepresentative.address.zip_code"
            label="cep"
            :error="errors.has('cep')"
            :error-messages="errors.first('cep')"
            v-validate="'required|numeric'"
            mask="#####-###"
          />
        </v-flex>
      </v-layout>
      <!-- STATE, CITY AND DISTRICT -->
      <v-layout align-center justify-space-between row wrap>
        <v-flex px-1 md4 xs12>
          <v-text-field
            name="bairro"
            v-model="legalRepresentative.address.district"
            label="bairro"
            :error="errors.has('bairro')"
            :error-messages="errors.first('bairro')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md4 xs12>
          <v-text-field
            name="cidade"
            v-model="legalRepresentative.address.city"
            label="cidade"
            :error-messages="errors.first('cidade')"
            :error="errors.has('cidade')"
            v-validate="'required'"
          />
        </v-flex>

        <v-flex px-1 md4 xs12>
          <v-text-field
            name="UF"
            v-model="legalRepresentative.address.state"
            label="UF"
            :error="errors.has('UF')"
            :error-messages="errors.first('UF')"
            v-validate="'required'"
          />
        </v-flex>
      </v-layout>
    </template>

    <template slot="footer">
      <v-btn color="primary" outlined small @click="$emit('close')">
        <span>fechar</span>
      </v-btn>
      <v-btn color="primary" small :loading="preloader" @click="submit">
        <span>cadastrar</span>
      </v-btn>
    </template>
  </modal>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Customers/Legals/New.vue